module.exports = __webpack_public_path__ + "static/media/texture-violet.a1558172.png";